export const ru = {
    'try-later': 'Произошла ошибка, попробуйте еще раз'
};
